module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-left-square-fill-c63fb975.svg";